import { Building2 } from 'lucide-react'

import type { Campaign } from 'models/campaign'

interface Props {
  campaign: Campaign
}

export function CampaignDashboardDealsTab({ campaign }: Props) {
  const dealCount = campaign.deal_count ?? 0

  if (dealCount === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="mb-3 rounded-full bg-surface-muted p-4">
          <Building2 className="size-8 text-fg-muted" />
        </div>
        <p className="text-base text-fg">No deals yet</p>
        <p className="mt-1 text-sm text-fg-secondary">
          Deals will appear here when contacts respond and deals are created.
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <p className="text-sm text-fg-secondary">
          {dealCount} deal{dealCount !== 1 ? 's' : ''} from this campaign
        </p>
      </div>

      <div className="rounded-lg border border-line bg-surface p-6">
        <p className="text-sm text-fg-secondary">
          Deal details are available on the individual deal pages. This campaign
          has generated <span className="font-medium text-fg">{dealCount}</span>{' '}
          deal
          {dealCount !== 1 ? 's' : ''}.
        </p>
      </div>
    </div>
  )
}
